import React, { useState, useEffect } from "react";

function FilmForm({ onSave, editingFilm }) {

  const [film, setFilm] = useState({
    ad: "",
    tur: "",
    tarih: "",
    puan: "",
    not: ""
  });

  useEffect(() => {
    if (editingFilm) {
      setFilm(editingFilm);
    }
  }, [editingFilm]);

  const handleChange = (e) => {
    setFilm({
      ...film,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(film);

    setFilm({
      ad: "",
      tur: "",
      tarih: "",
      puan: "",
      not: ""
    });
  };

  return (
    <div className="card shadow-lg border-10 mb-4">
      <div className="card-body">
        
        <h4 className="mb-3">
          {editingFilm ? "🎬 Film Güncelle" : "🎬 Film Ekle"}
        </h4>

        <form onSubmit={handleSubmit}>
          <div className="row g-3">

            <div className="col-md-12">
              <input
                className="form-control"
                name="ad"
                placeholder="Film Adı"
                value={film.ad}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="col-md-12">
              <input
                className="form-control"
                name="tur"
                placeholder="Tür"
                value={film.tur}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <input
                type="tarih"
                className="form-control"
                name="tarih"
                placeholder="Tarih"
                value={film.tarih}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <select
                className="form-select"
                name="puan"
                value={film.puan}
                onChange={handleChange}
              >
                <option value="">Puan</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>

            <div className="col-md-12">
              <textarea
                className="form-control"
                name="not"
                placeholder="Not"
                value={film.not}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12">
              <button className="btn btn-dark w-100 py-2 rounded-3">
                <h4 className="fw-semibold mb-3"> {editingFilm ? "🎬 Film Güncelle" : "🎬 Yeni Film Ekle"}</h4>
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  );
}

export default FilmForm;